/*
 * @Description: 
 * @Autor: yd
 * @Date: 2020-06-29 16:42:29
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-02-07 09:50:02
 */
export default {
  computed: {
    requiredRule () {
      return [{
        rule: 'required',
        msg: this.$t('verify_Required')
      }]
    },
    urlRule () {
      return [{
        rule: 'url',
        msg: this.$t('verify_The_URL_is_in_the_wrong_format')
      }]
    },
    integerRule () {
      return [{
        rule: 'integer',
        msg: this.$t('verify_Please_enter_the_integer_value')
      }]
    },
    emailRule () {
      return [{
        rule: 'email',
        msg: this.$t('verify_The_mailbox_format_is_wrong')
      }]
    },
    numericRule () {
      return [{
        rule: 'numeric',
        msg: this.$t('verify_Only_numbers_can_be_entered')
      }]
    },
    nocharacter () {
      return [{
        rule: 'nocharacter',
        msg: this.$t('verify_You_cannot_enter_illegal_characters')
      }]
    },
    noSpaces () {
      return [{
        rule: 'noSpaces',
        msg: this.$t('message_No_spaces')
      }]
    },
    onlyNum () {
      return [{
        rule: 'onlyNum',
        msg: this.$t('verify_onlyNum')
      }]
    },
  },
  methods: {
    maximumLengthRule (num = 50) {
      return [{
        rule: 'maximumLength',
        msg: this.$t('verify_The_most_input') + `${num}` + this.$t('verify_Character')
      }]
    },
    maxLength (num = 50) {
      return [{
        rule: 'maxLength',
        msg: this.$t('verify_The_most_input') + `${num}` + this.$t('verify_Character')
      }]
    },
    between (str) {
      return [{
        rule: 'between',
        msg: this.$t('verify_Please_enter') + `${str}` + this.$t('label_digital')
      }]
    },
    sameAsKey (str) {
      return [{
        rule: 'sameAsKey',
        // msg: this.$t('verify_Entered_twice') + `${str}` + this.$t('verify_Inconsistent')
        msg: this.$t('verify_two_passwords_are_inconsistent') 
      }]
    },
    // 校验方法
    isChina (val) {
      const reg = new RegExp("[\\u4E00-\\u9FFF]+", "g")
      return !reg.test(val)
    },
    illegal (val) {
      return !/[#<>{}()|/\+-=\[\]]/.test(val)
    },

    /**
     * 
     * @param {对象名字} objName 
     * @param {属性名字} name 
     * @param {校验的类型 和 对应的提示消息} arr 
     */
    $errors (objName = null, name, arr) {
      // 校验参数可能是嵌套数据  嵌套数据那传过来的就是对象  此处只做一层嵌套
      const errors = []
      const dirty = objName ? !this.$v[objName][name].$dirty : !this.$v[name].$dirty
      if (dirty) return errors
      Array.isArray(arr) && arr.forEach(item => {
        objName
          ?
          !this.$v[objName][name][item.rule] && errors.push(item.msg) :
          !this.$v[name][item.rule] && errors.push(item.msg)
      })
      return errors
    },
  }
}